import isSubUrlOf from './isSubUrlOf';

/**
 * Expects an array of paths that are denylisted.
 *
 * @example
 *  isUrlDenylisted('/developer/builder', ['/developer/']);
 *  > true
 */
const isUrlDenylisted = (url: string, denylistedRoutePrefixes: string[]) => {
  return denylistedRoutePrefixes.some(path => isSubUrlOf(url, path));
};

export default isUrlDenylisted;
